import { Component } from "@angular/core";

@Component({
    selector: "app-infos",
    templateUrl: "./infos.component.html",
    styleUrls: ["./infos.component.scss"],
})
export class InfosComponent {
    constructor() {}

}
